module.exports = __webpack_public_path__ + "img/video_img1.3ba6ae8c.png";